const item = Object.freeze({
  Draft: 1,
  Submitted: 2,
  Published: 3,
});

export default item;
